export default __webpack_public_path__ + "static/media/kgv-02.dc761ea7.jpg";